import ActionTypes from './../actions/types';
import { setObjectToState } from './helper';
import { defaultState } from './defaultState';

/*eslint no-case-declarations: 0 */

const initialState = defaultState.mapAccommodationInfo;

export default (state = initialState, action) => {
  const {type} = action;

  switch (type) {
    case ActionTypes.UPDATE_MAP_ACCOMMODATION_INFO:
      const { clubName, dtmClose, dtmOpen, eventName, isOpen } = action;
      return setObjectToState(state, {clubName, dtmClose, dtmOpen, eventName, isOpen});

    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/mapAccommodationReducer.js